import { render, staticRenderFns } from "./CadastrarEditarFaqDialog.vue?vue&type=template&id=f794a0b8"
import script from "./CadastrarEditarFaqDialog.vue?vue&type=script&lang=js"
export * from "./CadastrarEditarFaqDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports